module.exports = __webpack_public_path__ + "static/media/23_plantilla_combo_rectangular_marco_comida_45.d9b3e1cb.png";